import { isAfter } from 'date-fns';

import { type UserPlan } from '~/types/Plan';
import { type FeatureFlags } from '~/utils/featureflags';

import { NEW_ONBOARDING_CUTOFF_DATE } from '../constants/onboarding.const';
import { OnboardingLocalStorageKeys } from '../types/onboarding.type';

type Onboarding2026Variation = (typeof FeatureFlags.ONBOARDING_2026.variations)[number];

export const isNewOnboardingVariation = (
  variation: Onboarding2026Variation | null | undefined,
): boolean => variation === 'variant' || variation === 'variant_2';

export const getIsPastOnboardingCutoff = (signedUpAtSeconds: number | undefined): boolean =>
  !!signedUpAtSeconds && isAfter(new Date(signedUpAtSeconds * 1000), NEW_ONBOARDING_CUTOFF_DATE);

export const formatTrialEndDate = (endDate: UserPlan['endDate'], language: string): string =>
  endDate
    ? new Intl.DateTimeFormat(language, {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
      }).format(endDate.toDate())
    : '';

export const setOnboardingInProgress = (value: boolean) =>
  localStorage.setItem(OnboardingLocalStorageKeys.ONBOARDING_IN_PROGRESS, value.toString());

export const getOnboardingInProgress = (): boolean =>
  localStorage.getItem(OnboardingLocalStorageKeys.ONBOARDING_IN_PROGRESS) === 'true';

const clearOldOnboardingLocalStorage = () =>
  localStorage.removeItem(OnboardingLocalStorageKeys.ONBOARDING_BUSINESS_TYPE);

export const clearOnboardingLocalStorage = () => {
  clearOldOnboardingLocalStorage();
  localStorage.removeItem(OnboardingLocalStorageKeys.ONBOARDING_IN_PROGRESS);
};
